var LanguageSelector, PNHeaderV2, User, gcxFlyout, gtgModal, inAppMessage, incognitoTest, stickyHeader, uncommentThirdPartyAssets;

if (!$(document.head).find('#sls, #sls-packaged').length || !(window._phantom || window.callPhantom)) {
  $(document.head).find('script').remove();
}

require('../../src/frontend/core/dom_js_shim');

require('./common/underscore_mixins');

require('./groupon_modules/groupon');

require('../../modules/gig_body/components/cookie_banner/frontend/main');

require('../../modules/gig_body/header/search_bar/frontend/index');

require('../../src/frontend/helper/lazyLoadImages');

require('./groupon_modules/performance');

LanguageSelector = require('../../modules/gig_body/header/language_menu/frontend/language_selector');

PNHeaderV2 = require('../../modules/gig_body/header/frontend/views/pn_header_v2');

stickyHeader = require('../../modules/gig_body/header/frontend/sticky_header');

inAppMessage = require('../../modules/in_app_messages/frontend/main');

require('../../modules/gig_body/components/back2top/frontend/main');

require('../../modules/google_maps/frontend/main');

require('../../modules/doubleclick/frontend/doubleclick');

require('./groupon_modules/verifyUserCookies');

require('./groupon_modules/loadSiteBlindado');

require('../../modules/qualtrics/frontend/qualtrics');

require('../../modules/gig_body/header/responsive_menu/frontend/view/responsive_menu');

gtgModal = require('../../modules/shared/modals/frontend/gtg-modal');

User = require('../../modules/gig_body/header/usernav/frontend/setup_user');

uncommentThirdPartyAssets = require('./groupon_modules/uncommentThirdPartyAssets');

gcxFlyout = require('../../modules/gig_body/header/sub_nav/frontend/init_flyout');

incognitoTest = require('../../src/frontend/helper/incognito').incognitoTest;

incognitoTest('desktop');

$(document).ready(function() {
  var $header, i, mMax, ref, ref1;
  gtgModal.init();
  mMax = Groupon.LS.mediaQueries.mMax;
  if (Groupon.LS.hasTouch && (typeof matchMedia === "function" ? matchMedia(mMax).matches : void 0)) {
    $(document.head).find('meta[name=viewport]').attr('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
  }
  if ($('html').hasClass('lt-ie10')) {
    $(document.body).removeClass('ls-resp responsive-funnel');
  }
  Groupon.Utils.lazyLoadImages();
  if (($header = $('.header-v2')).length) {
    Groupon.Modules.Header = new PNHeaderV2($header);
  }
  if (Groupon.PageFlags.isLegacyResponsive) {
    new Groupon.LS.Header.PNResponsiveMenu;
  }
  User.init();
  if ($('#ls-lang-selected').length) {
    new LanguageSelector();
  }
  if (document.getElementById('ls-cookie-banner')) {
    new CookieBanner('#ls-cookie-banner');
  }
  $('body').removeClass('no-js');
  if (!Optimize.delayBloodhound) {
    OptimizeSuite.initBloodhound();
  }
  $('a.t-back-link').not('[href]').on('click', function() {
    return history.back();
  });
  $('.getaways-tab-flyout [data-bhc$="ga-search"]').click(function() {
    Cookie.unset('flyOut_shown', '.groupon.com');
    return Cookie.unset('flyOut_shown');
  });
  if ((ref = Cookie.get('has_cpp')) === '1' || ref === 'true') {
    $('#user-my-page').removeClass('hidden');
  }
  if ($('#ZN_6YfZFn20DN7x5hH').length) {
    try {
      new Groupon.qualtrics(100, 'r', 'QSI_S_ZN_6YfZFn20DN7x5hH', '//zn6yfzfn20dn7x5hh-groupon.siteintercept.qualtrics.com/WRSiteInterceptEngine/?Q_ZID=ZN_6YfZFn20DN7x5hH&Q_LOC=' + encodeURIComponent(window.location.href)).start();
    } catch (error) {
      i = error;
    }
  }
  if ((ref1 = $("#subscribe_modal_container")) != null) {
    ref1.trigger('launchSubsUIModal');
  }
  return gcxFlyout.init();
});

$(window).on('load', function() {
  if (Optimize.delayBloodhound) {
    setTimeout((function() {
      return OptimizeSuite.initBloodhound();
    }), 100);
  }
  Groupon.Utils.lazyLoadImages({
    threshold: 200
  }, '.lazy-wl');
  new CartWidget('.cart-widget');
  new Groupon.Widgets.BackToTopButton;
  inAppMessage.init();
  if ($('.header-v2').length) {
    stickyHeader.init('search');
  }
  Groupon.verifyUserCookies();
  if ($('.footer-siteblindado-br').length) {
    Groupon.loadSiteBlindado();
  }
  uncommentThirdPartyAssets();
});

//# sourceMappingURL=data:application/json;base64,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
